var LanguageSelector, PNHeaderV2, User, gcxFlyout, gtgModal, inAppMessage, incognitoTest, stickyHeader, uncommentThirdPartyAssets;

if (!$(document.head).find('#sls, #sls-packaged').length || !(window._phantom || window.callPhantom)) {
  $(document.head).find('script').remove();
}

require('../../src/frontend/core/dom_js_shim');

require('./common/underscore_mixins');

require('./groupon_modules/groupon');

require('../../modules/gig_body/components/cookie_banner/frontend/main');

require('../../modules/gig_body/header/search_bar/frontend/index');

require('../../src/frontend/helper/lazyLoadImages');

require('./groupon_modules/performance');

LanguageSelector = require('../../modules/gig_body/header/language_menu/frontend/language_selector');

PNHeaderV2 = require('../../modules/gig_body/header/frontend/views/pn_header_v2');

stickyHeader = require('../../modules/gig_body/header/frontend/sticky_header');

inAppMessage = require('../../modules/in_app_messages/frontend/main');

require('../../modules/gig_body/components/back2top/frontend/main');

require('../../modules/google_maps/frontend/main');

require('../../modules/doubleclick/frontend/doubleclick');

require('./groupon_modules/verifyUserCookies');

require('./groupon_modules/loadSiteBlindado');

require('../../modules/qualtrics/frontend/qualtrics');

require('../../modules/gig_body/header/responsive_menu/frontend/view/responsive_menu');

gtgModal = require('../../modules/shared/modals/frontend/gtg-modal');

User = require('../../modules/gig_body/header/usernav/frontend/setup_user');

uncommentThirdPartyAssets = require('./groupon_modules/uncommentThirdPartyAssets');

gcxFlyout = require('../../modules/gig_body/header/sub_nav/frontend/init_flyout');

incognitoTest = require('../../src/frontend/helper/incognito').incognitoTest;

incognitoTest('desktop');

$(document).ready(function() {
  var $header, i, mMax, ref, ref1;
  gtgModal.init();
  mMax = Groupon.LS.mediaQueries.mMax;
  if (Groupon.LS.hasTouch && (typeof matchMedia === "function" ? matchMedia(mMax).matches : void 0)) {
    $(document.head).find('meta[name=viewport]').attr('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
  }
  if ($('html').hasClass('lt-ie10')) {
    $(document.body).removeClass('ls-resp responsive-funnel');
  }
  Groupon.Utils.lazyLoadImages();
  if (($header = $('.header-v2')).length) {
    Groupon.Modules.Header = new PNHeaderV2($header);
  }
  if (Groupon.PageFlags.isLegacyResponsive) {
    new Groupon.LS.Header.PNResponsiveMenu;
  }
  User.init();
  if ($('#ls-lang-selected').length) {
    new LanguageSelector();
  }
  if (document.getElementById('ls-cookie-banner')) {
    new CookieBanner('#ls-cookie-banner');
  }
  $('body').removeClass('no-js');
  if (!Optimize.delayBloodhound) {
    OptimizeSuite.initBloodhound();
  }
  $('a.t-back-link').not('[href]').on('click', function() {
    return history.back();
  });
  $('.getaways-tab-flyout [data-bhc$="ga-search"]').click(function() {
    Cookie.unset('flyOut_shown', '.groupon.com');
    return Cookie.unset('flyOut_shown');
  });
  if ((ref = Cookie.get('has_cpp')) === '1' || ref === 'true') {
    $('#user-my-page').removeClass('hidden');
  }
  if ($('#ZN_6YfZFn20DN7x5hH').length) {
    try {
      new Groupon.qualtrics(100, 'r', 'QSI_S_ZN_6YfZFn20DN7x5hH', '//zn6yfzfn20dn7x5hh-groupon.siteintercept.qualtrics.com/WRSiteInterceptEngine/?Q_ZID=ZN_6YfZFn20DN7x5hH&Q_LOC=' + encodeURIComponent(window.location.href)).start();
    } catch (error) {
      i = error;
    }
  }
  if ((ref1 = $("#subscribe_modal_container")) != null) {
    ref1.trigger('launchSubsUIModal');
  }
  return gcxFlyout.init();
});

$(window).on('load', function() {
  if (Optimize.delayBloodhound) {
    setTimeout((function() {
      return OptimizeSuite.initBloodhound();
    }), 100);
  }
  Groupon.Utils.lazyLoadImages({
    threshold: 200
  }, '.lazy-wl');
  new CartWidget('.cart-widget');
  new Groupon.Widgets.BackToTopButton;
  inAppMessage.init();
  if ($('.header-v2').length) {
    stickyHeader.init('search');
  }
  Groupon.verifyUserCookies();
  if ($('.footer-siteblindado-br').length) {
    Groupon.loadSiteBlindado();
  }
  uncommentThirdPartyAssets();
});

//# sourceMappingURL=data:application/json;base64,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
